var LanguageSelector, PNHeaderV2, User, gcxFlyout, gtgModal, inAppMessage, incognitoTest, stickyHeader, uncommentThirdPartyAssets;

if (!$(document.head).find('#sls, #sls-packaged').length || !(window._phantom || window.callPhantom)) {
  $(document.head).find('script').remove();
}

require('../../src/frontend/core/dom_js_shim');

require('./common/underscore_mixins');

require('./groupon_modules/groupon');

require('../../modules/gig_body/components/cookie_banner/frontend/main');

require('../../modules/gig_body/header/search_bar/frontend/index');

require('../../src/frontend/helper/lazyLoadImages');

require('./groupon_modules/performance');

LanguageSelector = require('../../modules/gig_body/header/language_menu/frontend/language_selector');

PNHeaderV2 = require('../../modules/gig_body/header/frontend/views/pn_header_v2');

stickyHeader = require('../../modules/gig_body/header/frontend/sticky_header');

inAppMessage = require('../../modules/in_app_messages/frontend/main');

require('../../modules/gig_body/components/back2top/frontend/main');

require('../../modules/google_maps/frontend/main');

require('../../modules/doubleclick/frontend/doubleclick');

require('./groupon_modules/verifyUserCookies');

require('./groupon_modules/loadSiteBlindado');

require('../../modules/qualtrics/frontend/qualtrics');

require('../../modules/gig_body/header/responsive_menu/frontend/view/responsive_menu');

gtgModal = require('../../modules/shared/modals/frontend/gtg-modal');

User = require('../../modules/gig_body/header/usernav/frontend/setup_user');

uncommentThirdPartyAssets = require('./groupon_modules/uncommentThirdPartyAssets');

gcxFlyout = require('../../modules/gig_body/header/sub_nav/frontend/init_flyout');

incognitoTest = require('../../src/frontend/helper/incognito').incognitoTest;

incognitoTest('desktop');

$(document).ready(function() {
  var $header, i, mMax, ref, ref1;
  gtgModal.init();
  mMax = Groupon.LS.mediaQueries.mMax;
  if (Groupon.LS.hasTouch && (typeof matchMedia === "function" ? matchMedia(mMax).matches : void 0)) {
    $(document.head).find('meta[name=viewport]').attr('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
  }
  if ($('html').hasClass('lt-ie10')) {
    $(document.body).removeClass('ls-resp responsive-funnel');
  }
  Groupon.Utils.lazyLoadImages();
  if (($header = $('.header-v2')).length) {
    Groupon.Modules.Header = new PNHeaderV2($header);
  }
  if (Groupon.PageFlags.isLegacyResponsive) {
    new Groupon.LS.Header.PNResponsiveMenu;
  }
  User.init();
  if ($('#ls-lang-selected').length) {
    new LanguageSelector();
  }
  if (document.getElementById('ls-cookie-banner')) {
    new CookieBanner('#ls-cookie-banner');
  }
  $('body').removeClass('no-js');
  if (!Optimize.delayBloodhound) {
    OptimizeSuite.initBloodhound();
  }
  $('a.t-back-link').not('[href]').on('click', function() {
    return history.back();
  });
  $('.getaways-tab-flyout [data-bhc$="ga-search"]').click(function() {
    Cookie.unset('flyOut_shown', '.groupon.com');
    return Cookie.unset('flyOut_shown');
  });
  if ((ref = Cookie.get('has_cpp')) === '1' || ref === 'true') {
    $('#user-my-page').removeClass('hidden');
  }
  if ($('#ZN_6YfZFn20DN7x5hH').length) {
    try {
      new Groupon.qualtrics(100, 'r', 'QSI_S_ZN_6YfZFn20DN7x5hH', '//zn6yfzfn20dn7x5hh-groupon.siteintercept.qualtrics.com/WRSiteInterceptEngine/?Q_ZID=ZN_6YfZFn20DN7x5hH&Q_LOC=' + encodeURIComponent(window.location.href)).start();
    } catch (error) {
      i = error;
    }
  }
  if ((ref1 = $("#subscribe_modal_container")) != null) {
    ref1.trigger('launchSubsUIModal');
  }
  return gcxFlyout.init();
});

$(window).on('load', function() {
  if (Optimize.delayBloodhound) {
    setTimeout((function() {
      return OptimizeSuite.initBloodhound();
    }), 100);
  }
  Groupon.Utils.lazyLoadImages({
    threshold: 200
  }, '.lazy-wl');
  new CartWidget('.cart-widget');
  new Groupon.Widgets.BackToTopButton;
  inAppMessage.init();
  if ($('.header-v2').length) {
    stickyHeader.init('search');
  }
  Groupon.verifyUserCookies();
  if ($('.footer-siteblindado-br').length) {
    Groupon.loadSiteBlindado();
  }
  uncommentThirdPartyAssets();
});

//# sourceMappingURL=data:application/json;base64,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
